let initialState={payload:{msg:'fetching',data:[]},action:"success"};
let Customers =(state=initialState.payload,action)=>{
    switch(action.type){
        case "success":{
                state={
                data:action.payload,
                msg:'fetched'
            };
            break;
        }
        default:{}

    }
return state;
}

export default Customers;




// WEBPACK FOOTER //
// ./src/redux/reducers/customers/customers.js